import React from 'react';

const InsectColumns = () => (
  <tr>
    <th>Actions</th>
    <th>Numéro</th>
    <th>Produit</th>
    <th>Manip. Produit</th>
    <th>
      Matériel
      <br />
      Complémentaire
    </th>
    <th>
      Manip. Matériel
      <br />
      Complémentaire
    </th>
    <th>Capture</th>
  </tr>
);

export default InsectColumns;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/types/InsectColumns.js